export const SidebarIdHelpCenterSettings = 'HELP_CENTER_SETTINGS' as const;
